import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, FormFeedback, Input, Label } from "reactstrap"
import { getCategoryUser } from "store/createTeam/action"


const ClientList = (props) => {
  const { clientsEmail, HandleSubmitClick, setCreateUserScreen, categoryId, subcategoryId } = props;
  const [selectedClient, setSelectedClient] = useState([])

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCategoryUser({ categoryId: categoryId, subcategoryId: subcategoryId }))
  }, []);

  useEffect(() => {
    if (!isEmpty(clientsEmail)) {
      const filteredSelectedClients = (clientsEmail || []).filter(ele => ele?.isSelected).map(el => el.email);
      setSelectedClient(filteredSelectedClients)
    }
  }, [clientsEmail])
  return <Form onSubmit={e => { e.preventDefault() }}>
    {(clientsEmail || []).map((item, index) => {
      if(item?.email === null){
        return false;
      } 
      return <div key={item?.email}>
        <div className="form-check mb-3">
          <Input className="form-check-input" type="checkbox" id={index}
            // defaultChecked
            defaultChecked={item?.isSelected}
            onClick={(e) => {
              const checkAlreadyExists = selectedClient.filter((ele) => ele == item?.email)
              if (!isEmpty(checkAlreadyExists)) {
                const FilteredLists = selectedClient.filter((ele) => ele != item?.email)
                setSelectedClient(FilteredLists)
              }
              else {
                const AddedCheckedLists = [...selectedClient, item?.email]
                setSelectedClient(AddedCheckedLists)
              }
            }} />
          <Label className="form-check-label" htmlFor={index}>{item?.email} </Label>
        </div>
      </div>
    })}
    <div className='d-flex'>
      {isEmpty(selectedClient) && <FormFeedback className='d-flex' type="invalid">
        Please select atleast one client
      </FormFeedback>}
    </div >
    <div className="text-end">
      <button
        type="button"
        color="primary"
        className="btn btn-secondary me-2"
        onClick={() => setCreateUserScreen(true)}
      >
        Add new
      </button>
      <button disabled={isEmpty(selectedClient)} type="submit" className="btn btn-primary save-user" onClick={() => HandleSubmitClick(selectedClient)} >
        Submit
      </button>
    </div>
  </Form>
}

export default ClientList